import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import MaxWidth from './MaxWidth.svelte';
import BottomNav from './BottomNav.svelte';
import Toast from '../shared/Toast.svelte';

var root_1 = $.from_html(`<main class="shell-content svelte-3j9u9kxur6pjo"><!></main> <!>`, 1);
var root = $.from_html(`<!> <!>`, 1);

function Shell($$anchor, $$props) {
	var fragment = root();
	var node = $.first_child(fragment);

	MaxWidth(node, {
		children: ($$anchor, $$slotProps) => {
			var fragment_1 = root_1();
			var main = $.first_child(fragment_1);
			var node_1 = $.child(main);

			$.snippet(node_1, () => $$props.children);
			$.reset(main);

			var node_2 = $.sibling(main, 2);

			BottomNav(node_2, {});
			$.append($$anchor, fragment_1);
		},
		$$slots: { default: true }
	});

	var node_3 = $.sibling(node, 2);

	Toast(node_3, {});
	$.append($$anchor, fragment);
}

if (import.meta.hot) {
	Shell = $.hmr(Shell);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3j9u9kxur6pjo');
		Shell[$.HMR].update(module.default);
	});
}

export default Shell;
import "bun-svelte:Shell.svelte-2iptptjx79p5o-style.css";